import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <h1 className="text-6xl font-bold text-primary-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-secondary-900 mb-4">
        Página não encontrada
      </h2>
      <p className="text-secondary-600 mb-8">
        A página que você está procurando não existe ou foi movida.
      </p>
      <Link to="/" className="btn btn-primary">
        Voltar para o início
      </Link>
    </div>
  )
}


